import React from "react";
import "../css/Overview.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const Overview = () => {
  const stats = [
    { title: "Total Bookings", value: "1,245" },
    { title: "Active Test Rides", value: "85" },
    { title: "Pending Leads", value: "312" },
    { title: "Total Revenue (MTD)", value: "₹4,52,000" },
  ];

  const bookingData = [
    { day: "1", nfirst: 12, diplos: 8, institutional: 5 },
    { day: "5", nfirst: 25, diplos: 18, institutional: 12 },
    { day: "10", nfirst: 40, diplos: 28, institutional: 20 },
    { day: "15", nfirst: 60, diplos: 45, institutional: 35 },
    { day: "20", nfirst: 75, diplos: 58, institutional: 50 },
    { day: "25", nfirst: 95, diplos: 70, institutional: 65 },
    { day: "30", nfirst: 120, diplos: 90, institutional: 80 },
  ];

  const recentBookings = [
    {
      customer: "Rahul Sharma",
      vehicle: "n-first i-max",
      category: "n-first",
      payment: "Token Paid",
    },
    {
      customer: "Anita Verma",
      vehicle: "diplos-max",
      category: "diplos",
      payment: "Full Payment",
    },
    {
      customer: "City College",
      vehicle: "n-first i-pro",
      category: "institutional",
      payment: "Refund Requested",
    },
  ];

  return (
    <div className="overview">
      <h2 className="page-title">Dashboard Overview</h2>

      {/* Stats Cards */}
      <div className="stats-grid">
        {stats.map((item, index) => (
          <div key={index} className="stat-card">
            <p className="stat-title">{item.title}</p>
            <h3 className="stat-value">{item.value}</h3>
          </div>
        ))}
      </div>

      {/* Line Graph */}
      <div className="chart-card">
        <h3>Bookings Growth (Last 30 Days)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={bookingData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="nfirst"
              stroke="#0A2EA0"
              strokeWidth={3}
              name="n-first"
            />
            <Line
              type="monotone"
              dataKey="diplos"
              stroke="#000000"
              strokeWidth={3}
              name="diplos"
            />
            <Line
              type="monotone"
              dataKey="institutional"
              stroke="#1f3fd1"
              strokeWidth={3}
              name="institutional"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Recent Bookings Table */}
      <div className="table-card">
        <h3>Recent Booking Payments</h3>
        <table>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Vehicle</th>
              <th>Category</th>
              <th>Payment Status</th>
            </tr>
          </thead>
          <tbody>
            {recentBookings.map((item, index) => (
              <tr key={index}>
                <td>{item.customer}</td>
                <td>{item.vehicle}</td>
                <td>{item.category}</td>
                <td>
                  <span
                    className={`status ${
                      item.payment === "Full Payment"
                        ? "paid"
                        : item.payment === "Token Paid"
                        ? "token"
                        : "refund"
                    }`}
                  >
                    {item.payment}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Overview;